import classNames from "classnames";
import React, { memo } from "react";

interface Props {
  title: string;
  count: number | string;
  subtitle?: string;
  variant?: "default" | "primary" | "warning" | "danger" | "purple";
  percentage?: number; // NEW — api-contract §3.3 / D3; rendered as "count (N.N%)"
}

// Tailwind 1.6.2 does not ship bg-gradient-* utilities, so the purple variant's
// gradient must be applied via inline style rather than a Tailwind class.
const PURPLE_GRADIENT = "linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)";

const SlaMetricCard = ({ title, count, subtitle, variant = "default", percentage }: Props) => {
  return (
    <div
      className={classNames(
        "flex flex-col justify-between p-5 rounded shadow-sm",
        {
          "bg-white text-black-80":      variant === "default",
          "bg-primary text-white":       variant === "primary",
          "bg-warning-light text-white": variant === "warning",
          "bg-error-light text-white":   variant === "danger",
          "text-white":                  variant === "purple",
        }
      )}
      style={{
        minWidth: 160,
        flex: 1,
        ...(variant === "purple" ? { backgroundImage: PURPLE_GRADIENT } : {}),
      }}
    >
      <div
        className={classNames("text-12 font-bold uppercase tracking-wide mb-2", {
          "text-white":    variant !== "default",
          "text-black-60": variant === "default",
        })}
      >
        {title}
      </div>
      <div
        className={classNames("text-40 font-bold leading-none mb-1", {
          "text-white": variant !== "default",
        })}
      >
        {count}
        {percentage !== undefined && (
          <span className="text-40 font-normal ml-2">
            ({percentage.toFixed(1)}%)
          </span>
        )}
      </div>
      {subtitle && (
        <div
          className={classNames("text-12", {
            "text-white opacity-80": variant !== "default",
            "text-black-40":        variant === "default",
          })}
        >
          {subtitle}
        </div>
      )}
    </div>
  );
};

export default memo(SlaMetricCard);
